import { isAUTLocale, isIRLLocale, visitDashboard } from '@raisin/cp-utils';
import { RAISIN_BANK_LOGO, RAISIN_LIGHT_BLUE_SITE_LOGO, RAISIN_LOGO } from '../../../constants';
export const getLogo = (isThemeV2, globalSettings, locale) => {
    var _a, _b;
    if (isAUTLocale(locale)) {
        return RAISIN_BANK_LOGO;
    }
    else if (isIRLLocale(locale)) {
        return RAISIN_LOGO;
    }
    else if (isThemeV2) {
        return RAISIN_LIGHT_BLUE_SITE_LOGO;
    }
    return (_b = (_a = globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.site_logo) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '';
};
export const getLogoItems = (isThemeV2, b2cUseNewDashboard, distributor_id, globalSettings, cobranding, locale = '') => {
    const dashboardUrl = visitDashboard(b2cUseNewDashboard, true);
    const logoItems = [
        {
            id: 'header-logo-bar-logo-link',
            href: dashboardUrl,
            url: getLogo(isThemeV2, globalSettings, locale),
            alt: '',
        },
    ];
    if (cobranding === null || cobranding === void 0 ? void 0 : cobranding.logo) {
        logoItems.push({
            id: 'header-logo-bar-partner-logo',
            href: dashboardUrl,
            url: cobranding.logo,
            alt: distributor_id,
        });
    }
    return logoItems;
};
export const getSkeletonLogoItems = (isThemeV2, locale) => {
    const logoItems = {
        'de-AT': [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: '/',
                url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt755c7d81254bfe8d/raisin-bank-logo.svg',
                alt: 'Raisin',
            },
        ],
        default: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: '/',
                url: isThemeV2
                    ? RAISIN_LIGHT_BLUE_SITE_LOGO
                    : 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
                alt: 'Raisin',
            },
        ],
    };
    return logoItems[locale] || logoItems.default;
};
//# sourceMappingURL=logos.js.map